import { render, staticRenderFns } from "./workTypeForm.vue?vue&type=template&id=5fb36682&"
import script from "./workTypeForm.vue?vue&type=script&lang=js&"
export * from "./workTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports